module.exports = __webpack_public_path__ + "static/home-our-vision-55212b68a26cab4dcf8f3f25fc8d730d.jpg";